import React from 'react'
import { connect } from 'react-redux'
import { Page } from '../../../components/page/Page'
import { DefaultFormToolBar } from '../../../components/toolbar/DefaultFormToolBar'
import { enums, icons, routes } from '../../../constants'
import { actions } from '../configuracaoBoleto.actions'
import { ConfiguracaoBoletoForm } from './ConfiguracaoBoletoForm'
import storage from '../../../services/stoage.service'
import utils from '../../../utils'
import _ from 'lodash'
import { logarAcesso } from '../../../services/api-log-acesso'

const mapStateToProps = (state) => {
  const messages = state.crudConfiguracaoBoletoState.messages
  const record = state.crudConfiguracaoBoletoState.currentRecord
  let disableUnit = false
  let currentUnit = storage.getUnit()
  if (currentUnit) {
    let unidade = {
      id: currentUnit.oid,
      value: currentUnit.sigla,
    }
    Object.assign(record, { unidade: unidade })
    disableUnit = true
  }

  let unidades = utils.getListIdValuesUnidadeFromEmpresa(storage.getCompany())

  return {
    record,
    messages,
    disableUnit,
    unidades,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setField: (field, value) => dispatch(actions.setField(field, value)),

    saveHandler: (event) => {
      dispatch(actions.save())
    },
    removeHandler: (event) => {
      dispatch(actions.remove())
    },
    newHandler: (event) => {
      dispatch(actions.makeNew())
    },
    loadById: (oid) => {
      dispatch(actions.loadById(oid))
    },

    onChangeField: (field, value) => {
      dispatch(actions.removeErrors([{ field }]))

      if (['unidade'].includes(field) && typeof value === 'object') {
        value = { id: value.oid, value: value.sigla }
      }

      dispatch(actions.setField(field, value))
    },
  }
}

class ConfiguracaoBoletoFormPageContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showDialogRemove: false,
    }

    actions.beforeFetchRecordSuccess = (data) => {
      return data
    }

    actions.afterSave = (dados) => {
      this.props.history.replace(`${routes.PATH_CONFIGURACAO_BOLETO}/${dados.oid}`)
    }

    actions.afterNew = () => {
      this.props.history.push(`${routes.PATH_CONFIGURACAO_BOLETO}/novo`)

      this.props.setField('oid', null)
      this.props.setField('numeroConvenioCobranca', '0')
      this.props.setField('codigoCarteiraCobranca', '0')
      this.props.setField('especieDocumento', { id: 1, value: 'DM – Duplicata Mercantil' })
      this.props.setField('numeroDocumento', '0')
      this.props.setField('dataEmissao', utils.getDataAtual())
      this.props.setField('formaEmissao', enums.FormaEmissao?.[0] || { id: 2, value: 'Cooperado emite e expede' })
      this.props.setField('numeroParcelas', 0)
      this.props.setField('tipoJurosMora', { id: 2, value: 'Percentual' })
      this.props.setField('percentualJurosMora', 1.0)
      this.props.setField('tipoMulta', { id: 2, value: 'Percentual' })
      this.props.setField('percentualMulta', 2.0)
      this.props.setField('instrucoes', 'Após vencimento cobrar 1% de juros ao mês e multa de 2%.')
    }

    actions.afterRemove = () => {
      this.props.history.replace(`${routes.PATH_CONFIGURACAO_BOLETO}`)
    }
  }

  componentDidMount() {
    const oidEntity = _.get(this, 'props.match.params.id', null)
    logarAcesso(oidEntity).then()
    if (oidEntity && parseInt(oidEntity)) {
      this.props.loadById(oidEntity)
    } else {
      this.props.newHandler()
    }
  }

  searchHandler = () => {
    this.props.history.push(`${routes.PATH_CONFIGURACAO_BOLETO}`)
  }

  hideDialog = () => {
    this.setState({ showDialogRemove: false })
  }

  buildHeader = () => {
    return <DefaultFormToolBar formPageContainer={this} />
  }

  clonarDados = () => {
    const clonedRecord = _.cloneDeep(this.props.record)

    this.props.newHandler()

    this.props.setField('oid', null)

    Object.keys(clonedRecord || {}).forEach((field) => {
      if (field === 'oid') return
      this.props.setField(field, clonedRecord[field])
    })
  }

  getBotoesPersonalizados = () => {
    let botoes = []
    if (this.props.record.oid && utils.nonNull(this.props.record.oid)) {
      let botao = {
        type: 'button',
        label: utils.getMessage(this.props.messages, 'configuracaoboleto.label.clonar'),
        className: 'p-button-success',
        onClick: (e) => this.clonarDados(),
        icon: icons.COPY_ICON,
      }
      botoes.push(botao)
    }
    return botoes
  }

  setCertificadoDigital = (data) => {
    const oid = _.get(data, 'oid', null)
    const nome = _.get(data, 'titularCommonName', '')

    this.props.setField('certificadoDigital.id', oid)
    this.props.setField('certificadoDigital.value', nome)
  }

  render() {
    const content = (
      <ConfiguracaoBoletoForm
        disableUnit={this.props.disableUnit}
        unidades={this.props.unidades}
        messages={this.props.messages}
        onChangeField={this.props.onChangeField}
        onComplete={this.props.onComplete}
        record={this.props.record}
        setCertificadoDigital={this.setCertificadoDigital}
      />
    )

    return <Page header={this.buildHeader()} content={content} />
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfiguracaoBoletoFormPageContainer)
